var _style, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "47px",
    height: "35px",
    viewBox: "0 0 47 35",
    style: {
      enableBackground: "new 0 0 47 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;opacity:0.4;fill:#333333;enable-background:new    ;}\n\t.st1{display:none;fill:#FFFFFF;}\n\t.st2{fill:#7389FF;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st3{fill:#2D55E8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.5,16c-9.5,0-20.4,3.1-24.1,6.8c-2.9,3-0.9,5.5,4.9,6.5c0.8,1.3,1.2,2.8,1.2,2.8l0.4,1.7l3.8-1.7 c0,0,3.4-1.5,6.9-2.8c7.6-1,14.5-3.5,17.4-6.4C53.7,19.1,49.1,16,39.5,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.2,6.6c-1.4-1.2-3.9-1.4-5.2-1.5h-0.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0h-0.1c-1.3,0-3.8,0.2-5.2,1.5 C15.9,6.8,13,9.3,13,13.9c0,0,0,4.5,0.1,5.9c0.1,0.6,0.3,1.8,1.8,1.6c0.8-0.1,1.4-0.4,1.4-2.9H21h1.2h4.7c0,2.6,0.6,2.8,1.4,2.9 c1.5,0.2,1.7-1,1.8-1.6c0.1-1.5,0.1-5.9,0.1-5.9C30.4,9.4,27.5,6.8,27.2,6.6z M17.4,16.9c-1.2,0-2.3-0.7-2.3-1.7 c0-0.9,1-1.7,2.3-1.7c1.2,0,2.2,0.7,2.2,1.7C19.6,16.1,18.6,16.9,17.4,16.9z M21.2,10.3h-5.9c0.7-2.6,2.3-3.5,2.3-3.5 c1-0.5,2.9-0.6,4.1-0.6c1.3,0,3.1,0.1,4.1,0.6c0,0,1.6,0.9,2.3,3.4h-5.9h-1V10.3z M26.2,16.9c-1.3,0-2.3-0.7-2.3-1.7 c0-0.9,1-1.7,2.3-1.7s2.3,0.7,2.3,1.7C28.5,16.1,27.5,16.9,26.2,16.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.2,33.4c-1.1,0-1.2-2.4-3.5-4.9c-2.5-2.7-4.5-2.1-7.1-4.2c-2.7-2.3-3.8-5.8-4-8.2C9.2,9.4,15.9,1.2,24.5,1.2 c8.6,0,15.4,8,14.9,14.9c-0.2,2.8-1.6,6.7-4.7,8.8c-2.7,1.9-4.8,1.1-7.2,3.5C25.3,30.8,25.4,33.4,24.2,33.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.9,38.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerOpen);
export default __webpack_public_path__ + "static/media/marker-open.75c8d0fb1bf6cd28e1499e8f504cf240.svg";
export { ForwardRef as ReactComponent };